import PeopleIcon from '@mui/icons-material/People';
import SubscriptionEdit from './SubscriptionEdit';
import SubscriptionList from './SubscriptionList';
import SubscriptionShow from './SubscriptionShow';

export default {
  list: SubscriptionList,
  edit: SubscriptionEdit,
  show: SubscriptionShow,
  icon: PeopleIcon,
  recordRepresentation: (record: any) => `${record.display_name} (${record.role})`,
};
